<template>
	<div>
		<k-autocomplete
			v-if="items"
			v-bind:items="items"
			v-model="selected"
			:label="label"
			:item-text="item_text_str"
      		:item-value="itemValue||'id'"
      		:clearable="(clearable == false ? false : true)"
			:disabled="disabled"
			:required="required||false"
			:rules="(required ? [(v) => !!v || label+' is required'] : undefined)"
			:multiple="multiple"
			:chips="multiple"
			:small-chips="multiple"
			:deletable-chips="multiple"
		></k-autocomplete>
	</div>
</template>

<script>
import Vue from 'vue';
import Mustache from 'mustache'

export default {
	props: ["list_id", "list_name", "value", "label", "disabled", "clearable", "required", "autoselect_first", "item-text", "item-value", "multiple"],
	data () {
		return {
			items: undefined,
			selected: this.get_id(this.value)
		}
	},
	watch: {
		selected: function(new_val) {
			var val = undefined;
			if(!_.isEmpty(this.itemValue)) {
				val = new_val;
			} else if(this.multiple) {
				val = _.filter(this.items, (item) => {
					return new_val.indexOf(item.id) != -1;
				});
			} else {
				val = _.find(this.items, (item) => {
					return item.id == new_val;
				});
			}
			this.$emit("input", val)
		},
		value (newVal, oldVal) {
			if(!_.isEmpty(this.itemValue)) {
				if(_.difference(newVal, oldVal).length > 0 || !this.multiple) {
					this.selected = newVal;
				}
			} else if(_.differenceBy(newVal, oldVal, this.itemValue||'id').length > 0 || !this.multiple) {
				this.selected = this.get_id(newVal);
			}
		},
		list_id (newVal) {
			this.update_list();
		}
	},
	methods: {
		item_text_str(item) {
			if(_.isEmpty(this.itemText)) return _.get(item, "name", item);
			if(_.isArray(this.itemText)) return _.get(item, this.itemText, item);
			if(_.isObject(this.itemText)) {
				switch (this.itemText.type) {
					case "mustache":
						return Mustache.render(this.itemText.value, item);
						break;
					default:
						return item;
				}
			}
			return _.map(this.itemText.split(" "), (text) => {
				return _.get(item, text, text);
			}).join(" ")
		},
		get_id(val) {
			if(this.multiple && !_.isArray(val)) return [];
			if (!val) return undefined;
			if(!_.isEmpty(this.itemValue)) return val;
			if(this.multiple) return _.map(val, (item) => { return item.id });
			return val.id;
		},
		update_list() {
			if(!this.list_id) return;
			var url = "content_list/" + this.list_id;
			if (typeof(this.list_name) != "undefined") {
				url = "content_list/by_name/" + this.list_name;
			}
			Vue.http.get(url).then((response) => {
				// Sort content list
				// TODO Add configurable sorting and group
				let list_data = response.body

				if(list_data.length > 0) {
					list_data.sort((item1, item2) => {
						let item1_name = this.item_text_str(item1).toLowerCase()
						let item2_name = this.item_text_str(item2).toLowerCase()

						if(item1_name < item2_name) return -1
						if(item1_name > item2_name) return 1
						return 0
					})
				}

				this.items = list_data

				if(_.isEmpty(this.selected) && this.autoselect_first && this.items[0]) {
					if(this.multiple) {
						this.selected = [_.get(this.items[0], "id")];
					} else {
						this.selected = _.get(this.items[0], "id");
					}
				}
			}, (response) => {

			});
		}
	},
	mounted () {
		this.update_list();
	}
}
</script>
